// extracted by mini-css-extract-plugin
export default {"navbar":"Nav_navbar__MFe+0"};